module.exports = __webpack_public_path__ + "img/az.dd098b16.png";